<template>
  <v-container v-if="emergencyNewsList.length > 0">
    <div v-for="(value, index) in emergencyNewsList" :key="index">
      <v-row no-gutters>
        <v-col cols="12">
          <v-sheet class="ma-2 news_card" variant="outlined">
            <span style="white-space: pre-wrap">{{
              value.emergency_news_contents
            }}</span>
            <div style="width: 100%; text-align: right">
              <span style="font-weight: normal; white-space: pre-wrap"
                >({{ value.update_date.substring(0, 10) }})</span
              >
            </div>
          </v-sheet>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script setup lang="ts">
defineProps({
  emergencyNewsList: {
    type: Array,
    default: () => [],
  },
});
</script>
